<div class="table-header py-3 px-3">
  <div class="header-content">
    <h2 class="table-title">{{ 'app.settings.role_management.table.title' | translate }}</h2>
    <button mat-icon-button (click)="facade.reload()"
      class="d-flex align-items-center justify-content-center focus-outline-none"
      [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="facade.isLoading()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  @if (facade.count()) {
  <div class="count-line">
    <span class="count-badge">{{ facade.count() }}</span>
    <span class="count-label">{{ 'app.settings.role_management.table.roles_found_suffix' | translate }}</span>
  </div>
  }
</div>
<div class="table-wrapper">
  <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.role_management.table.columns.index' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index">{{ (facade.pageIndex() * facade.pageSize()) + i + 1 }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
        {{ 'app.settings.role_management.table.columns.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="intune_group">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.settings.role_management.table.columns.intune_group' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.intune_group?.displayName) {
        <span>{{ row.intune_group.displayName }}</span>
        } @else {
        <span>{{ 'shared.general.labels.na' | translate }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="permissions">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'app.settings.role_management.table.columns.permissions' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (row.permissions_count) {
        <span class="count-badge" [matTooltip]="permissionList(row)">{{ row.permissions_count }}</span>
        } @else {
        <span>{{ 'shared.general.labels.na' | translate }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="created_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">{{
        'app.settings.role_management.table.columns.created_date' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ (row.created_at | date: 'dd/MM/yyyy') ?? 'shared.general.labels.na' | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.role_management.table.columns.action' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        @if (!row.is_read_only) {
        @if(currentUser()?.hasPermission(permissions.ROLE_EDIT)) {
        <a class="me-2" [routerLink]="['/settings/roles/edit', row.id]" [style.color]="'var(--avyna-color-primary)'">
          {{ 'shared.general.buttons.edit' | translate }}
        </a>
        }
        @if(currentUser()?.hasPermission(permissions.ROLE_DELETE)) {
        <a class="delete-action" [style.color]="'var(--avyna-color-error)'" (click)="confirmAndDeleteRole(row)">
          {{ 'shared.general.buttons.delete' | translate }}
        </a>
        }
        } @else {
        <mat-icon>cancel</mat-icon>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (dataSource().data.length === 0) {
  <div class="no-data-content mt-5 pt-5">
    @if (facade.isLoading()) {
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'app.settings.role_management.table.loading' | translate }}</span>
    } @else {
    <span>{{ 'app.settings.role_management.table.no_data' | translate }}</span>
    }
  </div>
  }

  <app-table-loading-bar [isLoading]="facade.isLoading()"></app-table-loading-bar>
</div>

@if (facade.count() > 0) {
<mat-paginator class="pagination-bar" [length]="facade.count()" [pageIndex]="facade.pageIndex()"
  [pageSize]="facade.pageSize()" [pageSizeOptions]="[facade.pageSize()]" [hidePageSize]="true"
  [showFirstLastButtons]="true" (page)="onPageChange($event)">
</mat-paginator>
}